import React from 'react';
//Components
import PopUpS from './popupsmall';
//Material-UI
import { Button } from '@material-ui/core';
//Icons
import { Trash } from 'tabler-icons-react';
//Context
import { useOrdProd } from './OrdProdContext';

export default function BorrarOrd() {
    const { delOrd, selectionModel, isDel, setBorrar } = useOrdProd();

    const delOrds = (event) => {
        event.preventDefault();
        const lon = selectionModel.length;

        selectionModel.forEach((item, pos) => {
            delOrd(item, lon - (pos + 1));
        });
        setBorrar(false);
    };

    return (
        <PopUpS
            colorButton="default"
            buttonClass="actions-del"
            textButton={
                <div>
                    <Trash size={20} className="icon" /> Borrar
                </div>
            }
            popupSeconButton="Cancelar"
            isContained="text"
            isActive={isDel}
            popupBody={
                <div className="popup-confirm-body">
                    <div className="popup-confirm-icon">
                        <Trash size={128} color="#7D7F90" />
                    </div>
                    <p className="popup-confirm-message">
                        ¿Está seguro que desea eliminar las órdenes seleccionadas?
                    </p>
                </div>
            }
            popupPrimAction={
                <Button
                    color="primary"
                    variant="contained"
                    className="btn-guardar"
                    onClick={(event) => delOrds(event)}
                >
                    Borrar
                </Button>
            }
        />
    );
}
